<nav
    class="navbar navbar-expand-nn fixed-top navbar-dark"
    role="navigation"
    [attr.aria-busy]="!navLoaded && !navError"
    [ngClass]="{ 'cmps-navbar-fixed-overflow': !isCollapsed }"
>
    <div
        class="navbar-collapse"
        id="navNavbar"
        [ngbCollapse]="isCollapsed"
    >
        <span class="navbar-brand d-flex align-items-center">
            <img
                class="cmps-nav-logo"
                src="assets/compas-logo-new.svg"
                alt
                role="presentation"
            />
        </span>
        <ul
            class="navbar-nav"
            role="menubar"
            aria-label="Navigation"
        >
            <!--TODO revise. handle errors better-->
            <li
                role="none"
                *ngIf="!nav || !nav.length || navError"
            >
                <span class="nav-link">{{
                    navError
                        ? i18n._676_COULDN_T_LOAD_NAVIGATION_
                        : (!nav || !nav.length) && navLoaded
                        ? i18n._677_NAVIGATION_IS_EMPTY_
                        : (i18n._675_LOADING_NAVIGATION_ | translate)
                }}</span>
            </li>
            <ng-template
                ngFor
                let-i
                let-ii="index"
                [ngForOf]="nav"
            >
                <ng-container
                    *ngTemplateOutlet="
                        i.hasChildren && !i.isNested
                            ? dropdown
                            : i.isNested
                            ? card
                            : single;
                        context: {
                            item: i,
                            index: ii,
                            tabIndex: ii === 0 ? 0 : -1
                        }
                    "
                ></ng-container>
            </ng-template>
        </ul>
    </div>
    <div class="d-flex">
        <button
            type="button"
            class="navbar-toggler d-nn-none"
            [attr.aria-label]="'Toggle navigation' | translate"
            aria-haspopup="true"
            aria-controls="navNavbar"
            [attr.aria-expanded]="!isCollapsed"
            (click)="onToggleNavigationClick($event)"
        >
            <span class="navbar-toggler-icon"></span>
        </button>
        <div
            class="navbar-nav flex-row ml-auto"
            role="menubar"
            aria-label="Account"
        >
            <cmps-event-centre-nav-button></cmps-event-centre-nav-button>
            <cmps-teamscall-chat-menu-nav-button></cmps-teamscall-chat-menu-nav-button>
            <div class="nav-item">
                <div
                    class="cmps-nav-icon"
                    tabindex="0"
                    role="menuitem"
                    [attr.aria-label]="'Toggle notification panel' | translate"
                    aria-haspopup="true"
                    aria-controls="notificationPanel"
                    [attr.aria-expanded]="isNotificationPanelOpen"
                    [ngClass]="{ active: isNotificationPanelOpen }"
                    (click)="onNotificationBellClick($event)"
                >
                    <div class="cmps-nav-padding">
                        <div>
                            <span
                                class="badge badge-pill badge-danger"
                                *ngIf="newNotificationCount > 0"
                                >{{ newNotificationCount }}</span
                            >
                            <cmps-icon svgIcon="email-outline"></cmps-icon>
                        </div>
                        <div class="line"></div>
                    </div>
                </div>
            </div>
            <div
                class="nav-item cmps-nav-profile"
                routerLinkActive="active"
                ngbDropdown
                placement="bottom-right"
                [id]="'navbarDropdownProfile'"
                [attr.id]="'navbarDropdownProfile'"
                *ngIf="user"
            >
                <a
                    class="nav-link"
                    href
                    tabindex="-1"
                    role="menuitem"
                    (click)="$event.preventDefault()"
                    ngbDropdownToggle
                >
                    <div
                        class="cmps-nav-icon"
                        aria-hidden="true"
                    >
                        <img
                            [src]="photoUrl"
                            alt
                            *ngIf="hasPhotoUrl"
                        />
                        <cmps-icon
                            svgIcon="account-circle"
                            *ngIf="!hasPhotoUrl"
                        ></cmps-icon>
                    </div>
                    <div class="cmps-nav-padding">
                        <span
                            class="d-none d-lg-block"
                            [attr.aria-label]="
                                i18n._678_LOGGED_IN_AS__NAME_
                                    | translate
                                        : {
                                              name:
                                                  user.firstName +
                                                  ' ' +
                                                  user.lastName
                                          }
                            "
                            >{{ user.firstName }} {{ user.lastName }}</span
                        >
                        <div class="line"></div>
                    </div>
                </a>
                <div
                    role="menu"
                    ngbDropdownMenu
                >
                    <span
                        class="dropdown-item disabled d-lg-none"
                        [attr.aria-label]="
                            i18n._678_LOGGED_IN_AS__NAME_
                                | translate
                                    : {
                                          name:
                                              user.firstName +
                                              ' ' +
                                              user.lastName
                                      }
                        "
                        >{{ user.firstName }} {{ user.lastName }}</span
                    >
                    <div
                        class="dropdown-divider d-lg-none"
                        role="separator"
                    ></div>
                    <a
                        class="dropdown-item"
                        tabindex="-1"
                        role="menuitem"
                        routerLink="/profile"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{
                            paths: 'exact',
                            queryParams: 'exact',
                            fragment: 'ignored',
                            matrixParams: 'ignored'
                        }"
                    >
                        {{ i18n._679_MY_PROFILE | translate }}
                    </a>
                    <a
                        class="dropdown-item"
                        role="menuitem"
                        routerLink="/logout"
                        >{{ i18n._108_LOGOUT | translate }}</a
                    >
                </div>
            </div>
        </div>
    </div>
</nav>

<ng-template
    #single
    let-item="item"
    let-tabIndex="tabIndex"
>
    <li
        class="nav-item"
        role="none"
    >
        <cmps-nav-link
            className="nav-link"
            [tabIndex]="tabIndex"
            role="menuitem"
            [navItem]="item"
        >
            <ng-template
                cmpsNavLinkContent
                let-navItem="navItem"
            >
                <div class="cmps-nav-padding">
                    <span>{{ navItem.defaultName }}</span>
                    <div class="line"></div>
                </div>
            </ng-template>
        </cmps-nav-link>
    </li>
</ng-template>
<ng-template
    #dropdown
    let-item="item"
    let-index="index"
    let-tabIndex="tabIndex"
>
    <li
        class="nav-item"
        [class.active]="_childIsActive(item)"
        role="none"
        ngbDropdown
        [id]="'navbarDropdown' + index"
        [attr.id]="'navbarDropdown' + index"
    >
        <a
            class="nav-link"
            href
            [tabindex]="tabIndex"
            role="menuitem"
            (click)="$event.preventDefault()"
            ngbDropdownToggle
        >
            <div class="cmps-nav-padding">
                <span>{{ item.defaultName }}</span>
                <div class="line"></div>
            </div>
        </a>
        <div
            role="menu"
            ngbDropdownMenu
        >
            <ng-container *ngFor="let i of item.children">
                <cmps-nav-link
                    className="dropdown-item"
                    tabIndex="-1"
                    role="menuitem"
                    [activeOptions]="{
                        paths: 'exact',
                        queryParams: 'exact',
                        fragment: 'ignored',
                        matrixParams: 'ignored'
                    }"
                    [navItem]="i"
                >
                    <ng-template
                        cmpsNavLinkContent
                        let-navItem="navItem"
                    >
                        {{ navItem.defaultName }}
                    </ng-template>
                </cmps-nav-link>
            </ng-container>
        </div>
    </li>
</ng-template>
<ng-template
    #card
    let-item="item"
    let-index="index"
    let-tabIndex="tabIndex"
>
    <li
        class="nav-item"
        [class.active]="_childIsActive(item)"
        role="none"
        ngbDropdown
        [id]="'navbarDropdown' + index"
        [attr.id]="'navbarDropdown' + index"
        #dropdown="ngbDropdown"
        [cmpsDropdownCard]="dropdown"
    >
        <a
            class="nav-link"
            href
            [tabindex]="tabIndex"
            role="menuitem"
            (click)="$event.preventDefault()"
            ngbDropdownToggle
        >
            <div class="cmps-nav-padding">
                <span>{{ item.defaultName }}</span>
                <div class="line"></div>
            </div>
        </a>
        <div
            class="cmps-dropdown-deck"
            role="menu"
            ngbDropdownMenu
        >
            <div class="cmps-dropdown-card-holder">
                <div *ngFor="let i of item.children">
                    <div
                        class="cmps-dropdown-card"
                        *ngIf="i.children.length"
                    >
                        <span class="dropdown-item h5"
                            ><strong>{{ i.defaultName }}</strong></span
                        >
                        <ng-container *ngFor="let j of i.children">
                            <cmps-nav-link
                                className="dropdown-item"
                                tabIndex="-1"
                                role="menuitem"
                                [activeOptions]="{
                                    paths: 'exact',
                                    queryParams: 'exact',
                                    fragment: 'ignored',
                                    matrixParams: 'ignored'
                                }"
                                [navItem]="j"
                            >
                                <ng-template
                                    cmpsNavLinkContent
                                    let-navItem="navItem"
                                >
                                    {{ navItem.defaultName }}
                                </ng-template>
                            </cmps-nav-link>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </li>
</ng-template>
